import { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import { api, TELEGRAM } from "../lib/api";
import { Reveal, Item, Stagger } from "../components/Reveal";

const WM_TEXT = "t.me/Research_Network";

export const Watermark = ({ count = 12, onImage = false, className = "" }) => (
  <div className={`watermark ${onImage ? "on-image" : ""} ${className}`} aria-hidden>
    {Array.from({ length: count }).map((_, i) => <span key={i}>{WM_TEXT}</span>)}
  </div>
);

export default function AchievementsPage() {
  const { t } = useLang();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/achievements").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <main data-testid="achievements-page" style={{ position: "relative" }} onContextMenu={(e) => e.preventDefault()}>
      <Watermark count={15} className="page-watermark" />
      <div className="container" style={{ position: "relative" }}>
        <Reveal className="page-head"><span className="kicker">RESEARCHNETWORK</span><h1>{t.ach.title}</h1><p>{t.ach.sub}</p></Reveal>
        {items === null ? <div className="page-loader"><span className="loader" /></div>
          : items.length === 0 ? <div className="empty" data-testid="achievements-empty">{t.ach.empty}<br /><a href={TELEGRAM} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm" style={{ marginTop: 14 }}>Telegram</a></div>
          : <Stagger className="ach-grid" stagger={0.06}>{items.map((a) => (
            <Item className="ach-card" key={a.id} data-testid={`achievement-${a.id}`}>
              {a.image && <div className="ach-img"><img src={a.image} alt={a.title} loading="lazy" draggable={false} /><Watermark count={6} onImage /></div>}
              <div className="ach-body"><h3>{a.title}</h3>{a.description && <p>{a.description}</p>}
                <div className="ach-meta">{a.journal && <span className="badge badge-green">{a.journal}</span>}{a.date_label && <span className="badge badge-muted">{a.date_label}</span>}</div></div>
            </Item>))}</Stagger>}
        <div style={{ height: 80 }} />
      </div>
    </main>
  );
}
